import { render, staticRenderFns } from "./ViewAnnouncement.vue?vue&type=template&id=c3aa331c&scoped=true"
import script from "./ViewAnnouncement.vue?vue&type=script&lang=js"
export * from "./ViewAnnouncement.vue?vue&type=script&lang=js"
import style0 from "./ViewAnnouncement.vue?vue&type=style&index=0&id=c3aa331c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3aa331c",
  null
  
)

export default component.exports